<template>
  <div class="content">
    <div v-for="(result, indexType) in this.resultDef" :key="result.type + indexType" class="type">
      <h2>{{ result.title }}</h2>
      <div v-for="(answer, index) in results[result.type]" :key="index + answer.title" class="answer">
        <div v-if="results[result.type].length >= 1" class="question-number">
          {{ getIndex(indexType, index) }}
        </div>
        <div class="text">
          <h4>{{ answer.title }}</h4>
          <template v-if="typeof answer.answers === 'object'">
            <p v-for="text in answer.answers" :key="text">
              {{ `${answer.answers.length > 1 ? '• ' : ''}${text}` }}
            </p>
          </template>
          <template v-else>
            <p>{{ answer.answers }}</p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Summary',
  methods: {
    getIndex(type, questionIndex) {
      let count = 1;
      for (let i = 0; i <= type; i++) {
        if (i !== type) {
          count += this.results[this.resultDef[i].type].length;
        } else count += questionIndex;
      }
      return count >= 10 ? count : '0' + count;
    },
  },
  computed: {
    results() {
      return this.$store.getters.getResults;
    },
  },
  data: () => {
    return {
      indexQuestions: 0,
      resultDef: [
        {
          type: 'correct',
          title: 'Votre visite',
        },
        {
          title: 'Vos gênes visuelles',
          type: 'protect',
        },
        {
          title: 'Votre quotidien',
          type: 'optimize',
        },
      ],
    };
  },
};
</script>

<style scoped>
.content {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 2% 0;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.text {
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  padding-left: 0.8em;
  margin-left: 0.8em;
  flex-direction: column;
  align-items: flex-start;
  display: flex;
}
.answer {
  margin-top: 1em;
  display: flex;
}
.question-number {
  width: 20px;
  font-size: 1.5em;
}
p {
  text-align: left;
  margin: 0;
  font-size: 1vw;
}
.type:nth-child(2) {
  margin: 0 2vw;
}
.type {
  display: flex;
  flex-direction: column;
  text-align: left;
  max-height: 26vw;
  overflow-x: visible;
  overflow-y: auto;
  max-width: 33%;
}
h4 {
  font-size: 1vw;
  text-shadow: 0.2px 0 black;
  text-align: left;
  white-space: nowrap;
}
h2 {
  font-size: 1.5vw;
}
@media (max-width: 1024px), (max-height: 768px) {
  .type {
    max-height: 35vw;
  }
}
</style>
